const Drivers = () => import("./views/Drivers.vue");
const DriverEdit = () => import("./views/DriverEdit.vue");

const route = "/drivers";

export default [
  {
    path: route,

    name: "drivers.list",
    component: Drivers,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "drivers.create",
    component: DriverEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:driverId/edit`,
    name: "drivers.edit",
    component: DriverEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
